import React from 'react';

const ColorMapping = () => <div>ColorMapping</div>;

export default ColorMapping;
